/** @module app.test */

import { FrameworkConfiguration, Loader } from 'aurelia-framework';
import { TestContainer } from 'app/test/container';
import { EnvironmentService } from 'app/shared/services/environment-service';
import { TestModule } from 'app/test/module';

export function configure(config: FrameworkConfiguration) {
    config
        .singleton(TestModule.registrationKey, TestModule);

    const container = config.container.get(TestContainer) as TestContainer;
    if(container) {
        container.registerTests(
            'app/test/shared/date-time-tests',
            'app/test/shared/filter-objects-tests'
        );
    }

    const env = config.container.get(EnvironmentService) as EnvironmentService;
    if(env) {
        env.registerDebugObject('runAllTests', () => container.runAll());
    }

}

